import {
    PaymentForm,
    TaskEntityBase,
    TaskPhotosEntity,
    TaskStatus,
} from "tm-shared/types";

import { MutatePhotosOp } from "@/store/slices/progress";

export const createDefaultSaleState = () => ({
    products: {},
    paymentForm: PaymentForm.Card1,
    ignoreRemainings: [],
});

export const createTaskEntityBase = (): TaskEntityBase => ({
    status: TaskStatus.Incomplete,
});

export const createTaskEntityPhoto = (): TaskPhotosEntity => ({
    ...createTaskEntityBase(),
    photos: [],
});

export const updatePhotoIds = (
    photoIds: readonly string[],
    op: MutatePhotosOp,
): string[] => {
    switch (op.option) {
        case "add": {
            const { photo } = op;
            return photoIds.includes(photo)
                ? [...photoIds]
                : [...photoIds, photo];
        }

        case "remove": {
            const { photoId } = op;
            return photoIds.filter((id) => id !== photoId);
        }

        default:
            throw new Error(`Unhandled case`);
    }
};

export const mutateEntityPhotosAndStatus = <T extends TaskPhotosEntity>(
    target: T,
    op: MutatePhotosOp,
): T => {
    if (!target.photos) target.photos = [];

    target.photos = updatePhotoIds(target.photos, op);

    if (target.photos.length === 0) {
        target.status = TaskStatus.Incomplete;
        target.comment = "";
    } else {
        target.status = TaskStatus.Completed;
    }

    return target;
};
